// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="absolute top-0 left-0 w-full flex justify-between items-center px-6 py-4 z-50 bg-gradient-to-b from-black/60 to-transparent">
      <h1 className="text-2xl md:text-3xl font-extrabold text-white tracking-wide">
        ELION
      </h1>
      <div className="flex items-center gap-4">
        <span className="text-white text-sm md:text-base font-medium">
          Ja possui cadastro?
        </span>
        <Link
          to="/login"
          className="border border-white text-white font-medium px-4 py-2 rounded-full hover:bg-white hover:text-elion-navy transition"
        >
          Entrar
        </Link>
      </div>
    </header>
  );
};

export default Header;
